import { Injectable } from '@angular/core';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { IAuthenticationService, IUserInfo } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { DateFormat } from '@nimbus-library/features/localization/models/enums/language.enum';
import { PersistedLocalizationService } from '@nimbus-library/features/localization/services/persisted-localization.service';
import { CookieService } from '@nimbus-library/features/shared/services/cookies/cookies.service';
import { PortalPreferencesApiClient } from '@nimbus-library/features/user-settings/services/portal-preferences.api-client';

@Injectable()
export class LocalizationService extends PersistedLocalizationService {
  protected readonly languageCookieKey: string = 'user_language';
  protected readonly dateFormatCookieKey: string = 'user_dateFormat';
  // The Assistant reads the same plain cookies.
  protected readonly ownerScopedCookies: boolean = false;

  public constructor(
    protected readonly cookieService: CookieService,
    protected readonly preferencesApiClient: PortalPreferencesApiClient,
    protected readonly authenticationService: IAuthenticationService,
    protected readonly environmentConfigurationService: EnvironmentConfigurationService,
  ) {
    super(cookieService, preferencesApiClient, authenticationService, environmentConfigurationService);
  }

  // Before a date format was ever picked, the Portal formatted dates by the language.
  protected override readCachedDateFormat(user: IUserInfo | null): DateFormat | null {
    return super.readCachedDateFormat(user) ?? this.toDateFormat(this.readOwnCookie(this.languageCookieKey, user));
  }
}
